import React, { memo } from 'react';
import Loading from '../Components/Loading';

const withLoading = <BaseProps extends {}>(
  BaseComponent: React.ComponentType<BaseProps>
) => {
  type HocProps = {
    isDataLoading?: boolean;
    showLoadingText?: boolean;
    loadingText?: string;
    centerLoading?: boolean;
  };
  const HOC: React.ComponentType<HocProps & BaseProps> = ({
    isDataLoading,
    showLoadingText,
    loadingText,
    centerLoading,
    ...props
  }) => {
    if (isDataLoading) {
      return (
        <div css="padding: 20px 0; height: inherit; min-height: inherit">
          <Loading
            text={loadingText || null}
            noText={!showLoadingText}
            verticallyCentered={centerLoading}
          />
        </div>
      );
    }
    return <BaseComponent {...(props as BaseProps)} />;
  };

  return memo(HOC);
};

export default withLoading;
